// Quick task 260922-mmg: Force App Update admin page. Mirrors
// supportservices.js's shape — a single global settings row, no id param.
import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';

export const getAppSettings = async () => {
  const url = `${API_CONSTANTS.APP_SETTINGS}/detail`;
  const responseObj = await dataAccess.get(url);
  return responseObj;
};

export const updateAppSettings = async (values) => {
  const url = `${API_CONSTANTS.APP_SETTINGS}/update`;
  const payload = {
    data: {
      ...values,
    },
  };
  const responseObj = await dataAccess.put(url, payload);
  return responseObj;
};
